import { useState } from 'react';
import { ChevronDown, ChevronUp, UploadCloud, X } from 'lucide-react';
import { cancelUpload, useUploads } from '@/lib/upload';
import { formatBytes } from '@/lib/format';
import { Button, Progress } from './ui';

export function UploadsPanel() {
  const { items, clearFinished } = useUploads();
  const [collapsed, setCollapsed] = useState(false);
  const list = Object.values(items).sort((a, b) => b.startedAt - a.startedAt);
  if (list.length === 0) return null;
  const active = list.filter((i) => i.status === 'uploading' || i.status === 'finishing');
  const total = active.reduce((a, i) => a + i.size, 0);
  const loaded = active.reduce((a, i) => a + i.loaded, 0);
  return (
    <div className="fixed bottom-4 left-4 z-50 w-80 overflow-hidden rounded-xl border border-line bg-panel-2 shadow-2xl">
      <div className="flex items-center gap-2 border-b border-line px-3 py-2">
        <UploadCloud size={15} className="text-accent-2" />
        <div className="flex-1 text-sm font-medium">
          {active.length ? `Uploading ${active.length} file${active.length > 1 ? 's' : ''}` : 'Uploads complete'}
        </div>
        <Button variant="ghost" size="icon-sm" onClick={() => setCollapsed((c) => !c)}>
          {collapsed ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
        </Button>
        {active.length === 0 ? (
          <Button variant="ghost" size="icon-sm" onClick={clearFinished}>
            <X size={14} />
          </Button>
        ) : null}
      </div>
      {active.length ? <Progress value={loaded / Math.max(1, total)} className="rounded-none" /> : null}
      {!collapsed ? (
        <div className="max-h-64 overflow-auto">
          {list.map((i) => (
            <div key={i.assetId} className="flex items-center gap-2 px-3 py-2 text-xs">
              <div className="min-w-0 flex-1">
                <div className="truncate text-fg">{i.name}</div>
                <div className="text-faint">
                  {i.status === 'uploading'
                    ? `${formatBytes(i.loaded)} of ${formatBytes(i.size)}`
                    : i.status === 'finishing'
                      ? 'Finishing…'
                      : i.status === 'done'
                        ? 'Uploaded · processing'
                        : i.status === 'canceled'
                          ? 'Canceled'
                          : i.error}
                </div>
              </div>
              {i.status === 'uploading' ? (
                <button className="text-faint hover:text-fg" onClick={() => cancelUpload(i.assetId)} aria-label="Cancel upload">
                  <X size={14} />
                </button>
              ) : null}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
